import EmptyOrders from './EmptyOrders';

export default EmptyOrders;
